import { render, staticRenderFns } from "./Muelle.vue?vue&type=template&id=fedd1942&"
import script from "./Muelle.vue?vue&type=script&lang=js&"
export * from "./Muelle.vue?vue&type=script&lang=js&"
import style0 from "./Muelle.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports